/* =========================================================
   Prime Cuts — Appstle "Build Your Box" UI override (JS)
   Loaded only on /apps/bundles/* (path-gated in theme.liquid).

   Principles:
   - ONE MutationObserver, many jobs. Each job self-guards.
   - Re-assert injected content on presence (Appstle strips our nodes
     on re-render) — never a fire-once flag for anything Appstle repaints.
   - Read the FRESHEST node (app leaves stale duplicates).
   - NEVER destroy interactive Appstle nodes (card, next/prev) — restyle
     / augment in place only.

   Tag/category data source (Step 2 filters, category labels, badges):
   a JSON map printed at page render by snippets/pc-bundle-tag-map.liquid
   (<script id="pc-bundle-tag-map">). It is built from the "bundle-cuts"
   collection of the (now published) cut products, so Liquid can read each
   product's tags server-side. Cards are matched to products by normalized
   TITLE (image filename as a fallback). Requires the cut products to be
   PUBLISHED to the Online Store channel and carry category tags
   (beef/pork/chicken/lamb/sausage, + optional steak / premium / new /
   popular). See pc-bundle-tag-map.liquid for setup.

   Preselection / skip Step 1: ?plan=129 / ?plan=199 in the URL auto-selects
   the matching plan card and advances straight to Step 2.
   ========================================================= */
(function () {
  'use strict';

  var PLAN_BY_PRICE = {
    '129': {
      eyebrow: 'Plan · Flat Monthly',
      name: 'Small Box',
      tagline: 'Perfect for couples and smaller households',
      priceSuffix: '/mo',
      selections: '{N} selections · Cancel anytime',
      features: [
        'Choose {N} cuts each month',
        'Flat $129 — no surprise pricing',
        'Skip or swap anytime',
        'All eligible cuts included'
      ],
      featured: false
    },
    '199': {
      eyebrow: 'Plan · Flat Monthly',
      name: 'Large Box',
      tagline: 'Keep the freezer stocked for the whole family',
      priceSuffix: '/mo',
      selections: '{N} selections · Cancel anytime',
      features: [
        'Choose {N} cuts each month',
        'Flat $199 — no surprise pricing',
        'Skip or swap anytime',
        'All eligible cuts included'
      ],
      featured: true,
      badge: 'Most Popular'
    }
  };

  var STEP_HEAD = {
    eyebrow: 'Step 01 · Plan',
    h2: 'Pick Your <span class="display-italic">Plan.</span>',
    lede: 'One flat monthly price. Change plans, skip, or cancel anytime from your portal.'
  };

  var STEP_HEAD_2 = {
    eyebrow: 'Step 02 · Cuts',
    h2: 'Choose Your <span class="display-italic">Cuts.</span>',
    lede: 'Tap products to add them. Each product uses one selection. Fill your box — or leave room to try new things next month.'
  };

  // Hero above the flow (build-your-box.html)
  var HERO = {
    eyebrow: 'Build Your Box',
    h1: 'Your Box.<br>Your Meat. <span class="display-italic">Your Way.</span>',
    p: 'Flat monthly price. Choose from every eligible cut. Skip or swap anytime.'
  };

  var STEPPER = [ { label: 'Plan' }, { label: 'Cuts' }, { label: 'Review' }, { label: 'Cart' } ];

  var COMING_SOON = {
    icon: '+',
    name: 'More Sizes Coming',
    tagline: 'Additional plans, specialty boxes, and bulk subscriptions are in the works.',
    label: 'Stay Tuned'
  };

  function priceKey(text) { return (text || '').replace(/[^0-9]/g, ''); }

  function setBodyStep(step) {
    var b = document.body;
    b.classList.remove('byb-step-1', 'byb-step-2', 'byb-step-3');
    if (step) b.classList.add('byb-step-' + step);
  }

  function getPreselectPrice() {
    try {
      var raw = new URLSearchParams(window.location.search).get('plan');
      if (!raw) return null;
      var digits = priceKey(raw);
      if (digits) return digits;
      raw = raw.toLowerCase();
      if (raw.indexOf('large') > -1) return '199';
      if (raw.indexOf('small') > -1) return '129';
      return null;
    } catch (e) { return null; }
  }

  function detectStep() {
    var headings = document.querySelectorAll('.ab-fixed-pricing-heading-label');
    var heading = headings[headings.length - 1];
    if (!heading) return 0;
    var review = heading.querySelector('.ab-fixed-pricing-heading-review-order-label');
    if (review && review.textContent.trim()) return 3;
    var products = heading.querySelector('.ab-fixed-pricing-heading-choose-products-label');
    if (products && products.textContent.trim()) return 2;
    var plan = heading.querySelector('.ab-fixed-pricing-heading-choose-plan-label');
    if (plan && plan.textContent.trim()) return 1;
    return 0;
  }

  function injectHero() {
    var bundle = document.querySelector('#ab-fixed-pricing-bundle');
    if (!bundle) return;
    if (bundle.querySelector('.byb-hero')) return;
    var hero = document.createElement('section');
    hero.className = 'byb-hero';
    hero.innerHTML =
      '<div class="wrap">' +
        '<span class="eyebrow">' + HERO.eyebrow + '</span>' +
        '<h1>' + HERO.h1 + '</h1>' +
        '<p>' + HERO.p + '</p>' +
      '</div>';
    bundle.insertBefore(hero, bundle.firstChild);
  }

  function injectStepper(step) {
    var bundle = document.querySelector('#ab-fixed-pricing-bundle');
    if (!bundle) return;
    var stepper = bundle.querySelector('.byb-stepper');
    if (!stepper) {
      stepper = document.createElement('div');
      stepper.className = 'byb-stepper';
      var stepsHtml = '';
      STEPPER.forEach(function (s, i) {
        if (i > 0) stepsHtml += '<div class="byb-sep"></div>';
        stepsHtml +=
          '<div class="byb-stp" data-stp="' + (i + 1) + '">' +
            '<span class="byb-idx">' + (i + 1) + '</span>' +
            '<span class="byb-label">' + s.label + '</span>' +
          '</div>';
      });
      stepper.innerHTML = '<div class="wrap"><div class="byb-steps">' + stepsHtml + '</div></div>';
      // insert after the hero if present, else at top
      var hero = bundle.querySelector('.byb-hero');
      if (hero && hero.nextSibling) {
        bundle.insertBefore(stepper, hero.nextSibling);
      } else if (hero) {
        bundle.appendChild(stepper);
      } else {
        bundle.insertBefore(stepper, bundle.firstChild);
      }
    }
    stepper.querySelectorAll('.byb-stp').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-stp'), 10);
      el.classList.toggle('active', n === step);
      el.classList.toggle('done', n < step);
    });
  }

  function injectStepHead(cfg, beforeEl, marker) {
    if (!beforeEl) return;
    var parent = beforeEl.parentNode;
    if (parent.querySelector('.' + marker)) return;
    var head = document.createElement('div');
    head.className = 'byb-step-head-wrap ' + marker;
    head.innerHTML =
      '<div class="wrap">' +
        '<div class="byb-step-head">' +
          '<div>' +
            '<span class="eyebrow">' + cfg.eyebrow + '</span>' +
            '<h2 class="mt-3">' + cfg.h2 + '</h2>' +
          '</div>' +
          '<p class="lede">' + cfg.lede + '</p>' +
        '</div>' +
      '</div>';
    parent.insertBefore(head, beforeEl);
  }

  function augmentStep1() {
    var cards = document.querySelectorAll('.ab-single-source-product-item');
    cards.forEach(function (card) {
      var priceEl = card.querySelector('.ab-single-source-product-variant-price');
      var key = priceEl ? priceKey(priceEl.textContent) : '';
      var plan = PLAN_BY_PRICE[key];
      if (!plan) return;

      if (plan.featured) card.classList.add('byb-featured');

      if (!card.querySelector('.byb-plan-content')) {
        if (plan.badge && !card.querySelector('.byb-plan-badge')) {
          var badge = document.createElement('span');
          badge.className = 'byb-plan-badge';
          badge.textContent = plan.badge;
          card.appendChild(badge);
        }
        // Live cut count for THIS plan, straight from Appstle's config.
        // Falls back to "—" only if _ABConfig is unreadable (should never
        // happen; if it does, the em-dash is a loud visual signal).
        var settings = getSingleProductSettings();
        var liveMax = settings ? entryMax(findEntryForCard(card, settings)) : 0;
        var subN = function (s) { return s.replace(/\{N\}/g, liveMax || '—'); };

        var content = document.createElement('div');
        content.className = 'byb-plan-content';
        var featuresHtml = plan.features.map(function (f) {
          return '<li class="plan-feature">' + subN(f) + '</li>';
        }).join('');
        content.innerHTML =
          '<span class="plan-eyebrow">' + plan.eyebrow + '</span>' +
          '<div class="plan-name">' + plan.name + '</div>' +
          '<p class="plan-tag">' + plan.tagline + '</p>' +
          '<div class="plan-price"><sup>$</sup>' + key + '<em>' + plan.priceSuffix + '</em></div>' +
          '<div class="plan-selections">' + subN(plan.selections) + '</div>' +
          '<div class="plan-divider"></div>' +
          '<ul class="plan-features">' + featuresHtml + '</ul>';
        var info = card.querySelector('.ab-single-source-product-info');
        var details = card.querySelector('.ab-single-source-product-details');
        if (info && details) {
          info.insertBefore(content, details.nextSibling);
        } else if (info) {
          info.insertBefore(content, info.firstChild);
        } else {
          card.appendChild(content);
        }
      }
    });
  }

  var preselectDone = false;
  function applyPreselect() {
    if (preselectDone) return;
    var wantPrice = getPreselectPrice();
    if (!wantPrice || !PLAN_BY_PRICE[wantPrice]) { preselectDone = true; return; }

    var cards = document.querySelectorAll('.ab-single-source-product-item');
    if (!cards.length) return; // not ready, retry next tick

    var matched = null;
    cards.forEach(function (card) {
      var priceEl = card.querySelector('.ab-single-source-product-variant-price');
      if (priceEl && priceKey(priceEl.textContent) === wantPrice) matched = card;
    });
    if (!matched) return;

    if (matched.classList.contains('ab-single-source-selected-product')) {
      preselectDone = true;
      return;
    }
    var btn = matched.querySelector('.ab-single-source-product-select-button');
    (btn || matched).click();
    preselectDone = true;
  }

  /* Skip Step 1 when the plan was already chosen on join.html (?plan=129/199).
     applyPreselect() has selected the matching card; once Appstle marks it
     selected and enables its "Next" button, we click Next to jump straight to
     Step 2. Fires at most ONCE (guarded), so clicking "Back to Plan" from
     Step 2 does NOT re-advance the customer. With no ?plan= param it disarms
     immediately and normal Step-1 behaviour is unchanged. */
  var autoAdvanceDone = false;
  var autoAdvancePolling = false;

  // One attempt: advance to Step 2 iff the preselected card is selected AND
  // Appstle's Next is enabled. Idempotent — sets autoAdvanceDone after clicking.
  function attemptAutoAdvance() {
    if (autoAdvanceDone) return;
    var wantPrice = getPreselectPrice();
    if (!wantPrice || !PLAN_BY_PRICE[wantPrice]) { autoAdvanceDone = true; return; } // no preselect -> never auto-advance

    var cards = document.querySelectorAll('.ab-single-source-product-item');
    var selectedOk = false;
    cards.forEach(function (card) {
      var priceEl = card.querySelector('.ab-single-source-product-variant-price');
      if (priceEl && priceKey(priceEl.textContent) === wantPrice &&
          card.classList.contains('ab-single-source-selected-product')) {
        selectedOk = true;
      }
    });
    if (!selectedOk) return; // wait until Appstle marks it selected

    var next = document.querySelector('.ab-single-product-bab-next-button');
    if (!next || next.disabled || next.hasAttribute('disabled')) return; // wait until enabled
    next.click();
    autoAdvanceDone = true;
  }

  function applyAutoAdvance() {
    attemptAutoAdvance();
    if (autoAdvanceDone || autoAdvancePolling) return;
    // Selection + Next-enable are ATTRIBUTE changes; the childList observer
    // won't fire on them, so start ONE bounded poll to catch the ready state.
    var wantPrice = getPreselectPrice();
    if (!wantPrice || !PLAN_BY_PRICE[wantPrice]) return; // disarmed (no ?plan=)
    autoAdvancePolling = true;
    var tries = 0;
    (function poll() {
      if (autoAdvanceDone) return;
      attemptAutoAdvance();
      if (autoAdvanceDone) return;
      if (++tries < 40) setTimeout(poll, 100); // ~4s max, then give up (stay on Step 1)
    })();
  }

  function injectComingSoon() {
    var list = document.querySelector('.ab-fixed-pricing-source-products-list');
    if (!list) return;
    if (!list.querySelector('.ab-single-source-product-item')) return;
    list.classList.add('byb-has-coming-soon');
    if (list.querySelector('.byb-coming-soon-wrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'ab-fixed-pricing-product-item-wrapper byb-coming-soon-wrap';
    wrap.innerHTML =
      '<div class="plan-card coming-soon byb-coming-soon-card">' +
        '<div class="cs-icon">' + COMING_SOON.icon + '</div>' +
        '<div class="plan-name">' + COMING_SOON.name + '</div>' +
        '<p class="plan-tag" style="min-height:0;">' + COMING_SOON.tagline + '</p>' +
        '<span class="byb-coming-soon-label">' + COMING_SOON.label + '</span>' +
      '</div>';
    list.appendChild(wrap);
  }

  function setNavLabels(nextLabel, prevLabel) {
    // Next button (right)
    document.querySelectorAll('.ab-single-product-bab-next-button').forEach(function (btn) {
      var svg = btn.querySelector('svg');
      var hasText = false;
      btn.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && n.textContent.trim()) {
          if (n.textContent.trim() !== nextLabel) n.textContent = nextLabel;
          hasText = true;
        }
      });
      if (!hasText) btn.insertBefore(document.createTextNode(nextLabel), svg || null);
    });
    // Previous button (left)
    if (prevLabel) {
      document.querySelectorAll('.ab-single-product-bab-previous-button').forEach(function (btn) {
        var svg = btn.querySelector('svg');
        var hasText = false;
        btn.childNodes.forEach(function (n) {
          if (n.nodeType === 3 && n.textContent.trim()) {
            if (n.textContent.trim() !== prevLabel) n.textContent = prevLabel;
            hasText = true;
          }
        });
        if (!hasText) {
          // put label after the icon
          btn.appendChild(document.createTextNode(prevLabel));
        }
      });
    }
  }

  /* Inject a "Cancel" link on the left of the bottom nav (build-your-box
     .step-nav: Cancel left, Continue right). Re-inject on presence. */
  function injectCancel() {
    var container = document.querySelector('.ab-fixed-pricing-product-bottom-step-button-container');
    if (!container) return;
    container.classList.add('byb-step-nav');
    if (container.querySelector('.byb-cancel')) return;
    var cancel = document.createElement('a');
    cancel.className = 'byb-cancel';
    cancel.href = '/';
    cancel.innerHTML = '← Cancel';
    container.insertBefore(cancel, container.firstChild);
  }

  /* =======================================================
     TAG / CATEGORY DATA — from the server-rendered map only
     -------------------------------------------------------
     snippets/pc-bundle-tag-map.liquid prints a JSON map at page render:
       { "_meta": { collection, found, count },
         "byTitle": { "<normalized title>": { type, tags:[] }, ... },
         "byImage": { "<image filename>":   { type, tags:[] }, ... } }
     built from the "bundle-cuts" collection of the published cut products.

     We match each Step-2 card (and Step-3 review line) to its product by
     normalized TITLE first (stable, doesn't change on photo re-upload),
     with image filename as a fallback. Category comes from the product's
     tags (beef/pork/chicken/lamb/sausage); `type` is also read and treated
     as a category tag if present. This is the ONLY data source — Appstle
     puts no id/handle on the cards, so title/image are the join keys.
     ======================================================= */

  function normalizeTitle(t) { return (t || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

  // Last path segment of an image URL, lowercased, query stripped:
  //   ".../StewMeat.png?v=123" -> "stewmeat.png"
  function imageFileKey(url) {
    if (!url) return '';
    var clean = String(url).split('?')[0].split('#')[0];
    var seg = clean.substring(clean.lastIndexOf('/') + 1);
    return seg.toLowerCase();
  }

  function cardImageKey(card) {
    var img = card.querySelector('img[src]');
    return img ? imageFileKey(img.getAttribute('src')) : '';
  }

  var _tagMap;         // undefined = not parsed yet; null = absent/invalid
  var _tagMapWarned = false;

  function getTagMap() {
    if (_tagMap !== undefined) return _tagMap;
    var el = document.getElementById('pc-bundle-tag-map');
    if (!el) { _tagMap = null; return null; }
    try {
      var parsed = JSON.parse(el.textContent);
      _tagMap = (parsed && typeof parsed === 'object') ? parsed : null;
    } catch (e) { _tagMap = null; }

    // One-time console diagnostic so a mis-set collection is obvious.
    if (window.console && !_tagMapWarned) {
      _tagMapWarned = true;
      if (!_tagMap) {
        console.warn('[BYB] pc-bundle-tag-map present but unparseable.');
      } else if (_tagMap._meta && !_tagMap._meta.found) {
        console.warn('[BYB] tag-map: collection "' + _tagMap._meta.collection +
          '" NOT found — create it and set collection_handle in pc-bundle-tag-map.liquid.');
      } else if (_tagMap._meta && _tagMap._meta.count === 0) {
        console.warn('[BYB] tag-map: collection "' + _tagMap._meta.collection +
          '" is EMPTY — check its rules, and that the cut products are PUBLISHED to the Online Store channel.');
      } else if (_tagMap._meta) {
        console.log('[BYB] tag-map: collection "' + _tagMap._meta.collection +
          '" has ' + _tagMap._meta.count + ' products.');
      }
    }
    return _tagMap;
  }

  // Merge a map entry into one lowercased tag list. Accepts BOTH map shapes,
  // since the deployed snippet has varied over versions:
  //   (a) bare array of tags:       ["beef","steak"]
  //   (b) object with type + tags:  { type:"beef", tags:["beef","steak"] }
  function metaToTags(entry) {
    if (!entry) return [];
    var out = [];
    var push = function (t) {
      if (t == null) return;
      t = String(t).toLowerCase();
      if (t && out.indexOf(t) === -1) out.push(t);
    };
    if (Array.isArray(entry)) {
      entry.forEach(push);               // shape (a)
    } else if (typeof entry === 'object') {
      push(entry.type);                  // shape (b): type first (category)
      (entry.tags || []).forEach(push);
    }
    return out;
  }

  // Resolve a card's tags from the map: TITLE first, image filename fallback.
  // Returns [] if there's no map or no match (card produces no category/badge).
  function resolveCardTags(card) {
    var map = getTagMap();
    if (!map) return [];
    var titleEl = card.querySelector('.ab-product-title');
    var title = titleEl ? normalizeTitle(titleEl.textContent) : '';
    if (title && map.byTitle && map.byTitle[title]) return metaToTags(map.byTitle[title]);
    var imgKey = cardImageKey(card);
    if (imgKey && map.byImage && map.byImage[imgKey]) return metaToTags(map.byImage[imgKey]);
    return [];
  }

  // Quick check that the Appstle bundle config is readable.
  window.__bybBundleConfigDebug = function () {
    var rule = getCurrentBundleRule();
    if (!rule) return console.log('[BYB] no bundle rule found');
    var settings = getSingleProductSettings();
    if (!settings) return console.log('[BYB] singleProductSettings unreadable');
    var rows = settings.map(function (e) {
      var sp = e.sourceProduct || {};
      return { title: sp.title, price: sp.price, min: e.minQuantity, max: e.maxQuantity };
    });
    if (window.console && console.table) console.table(rows); else console.log(rows);
    console.log('[BYB] current plan max:', getConfigDerivedMax());
    return rows;
  };

  // Console diagnostic: per card, what it resolved to and how it matched.
  window.__bybTagDebug = function () {
    var map = getTagMap();
    var rows = [];
    document.querySelectorAll('.ab-associated-product-item').forEach(function (card) {
      var titleEl = card.querySelector('.ab-product-title');
      var title = titleEl ? titleEl.textContent.trim() : '(no title)';
      var imgKey = cardImageKey(card);
      var matchedBy = '(none)';
      if (map && title && map.byTitle && map.byTitle[normalizeTitle(title)]) matchedBy = 'map-title';
      else if (map && imgKey && map.byImage && map.byImage[imgKey]) matchedBy = 'map-image';
      rows.push({
        title: title,
        img: imgKey || '(none)',
        matchedBy: matchedBy,
        tags: resolveCardTags(card).join(', ') || '(none)'
      });
    });
    if (window.console) {
      console.log('[BYB] tag-map: ' + (map && map._meta ? ('"' + map._meta.collection + '" · ' + map._meta.count + ' products') : 'NOT PRESENT'));
    }
    if (window.console && console.table) console.table(rows); else console.log(rows);
    return rows;
  };

  // Category label from tags. First matching meat tag wins.
  var BYB_CATEGORY_TAGS = ['beef', 'pork', 'chicken', 'lamb', 'sausage'];
  var BYB_CATEGORY_LABEL = { beef: 'Beef', pork: 'Pork', chicken: 'Chicken', lamb: 'Lamb', sausage: 'Sausage' };
  // Badge priority mirrors build-your-box.html: New > Premium > Popular.
  var BYB_BADGES = [
    { tag: 'new', label: 'New', cls: 'new' },
    { tag: 'premium', label: 'Premium', cls: 'premium' },
    { tag: 'popular', label: 'Popular', cls: 'popular' }
  ];

  function categoryLabelFromTags(tags) {
    for (var i = 0; i < BYB_CATEGORY_TAGS.length; i++) {
      if (tags.indexOf(BYB_CATEGORY_TAGS[i]) > -1) return BYB_CATEGORY_LABEL[BYB_CATEGORY_TAGS[i]];
    }
    return '';
  }

  function badgeFromTags(tags) {
    for (var b = 0; b < BYB_BADGES.length; b++) {
      if (tags.indexOf(BYB_BADGES[b].tag) > -1) return BYB_BADGES[b];
    }
    return null;
  }

  /* =======================================================
     STEP 2 — Card inner-DOM restructure (build-your-box .pcard)
     -------------------------------------------------------
     Move the interactive add/qty control into a bottom row with the
     category label (from tags). Idempotent + re-asserted every tick
     (Appstle strips our nodes on re-render); guarded so a settled card
     makes no DOM writes. NEVER recreate the add/qty node — we MOVE it.
     ======================================================= */
  function augmentStep2() {
    var cards = document.querySelectorAll('.ab-associated-product-item');
    cards.forEach(function (card) {
      var info = card.querySelector('.ab-associated-product-info');
      var action = card.querySelector('.ab-associated-product-action-content');
      if (!info || !action) return; // card not fully rendered yet

      // Selected state: an added product shows the qty stepper.
      var added = !!card.querySelector('.ab-product-quantity');
      if (card.classList.contains('byb-selected') !== added) {
        card.classList.toggle('byb-selected', added);
      }

      var tags = resolveCardTags(card);

      // Bottom row (category left + action right).
      var bottom = info.querySelector('.byb-pcard-bottom');
      if (!bottom) {
        bottom = document.createElement('div');
        bottom.className = 'byb-pcard-bottom';
        var catSpan = document.createElement('span');
        catSpan.className = 'byb-pcard-cat';
        bottom.appendChild(catSpan);
        info.appendChild(bottom);
      }
      // Move the REAL interactive action node into the bottom row.
      if (action.parentNode !== bottom) bottom.appendChild(action);

      var catEl = bottom.querySelector('.byb-pcard-cat');
      var catLabel = categoryLabelFromTags(tags);
      if (catEl.textContent !== catLabel) catEl.textContent = catLabel;

      // Per-card badge (top-left overlay).
      var badge = badgeFromTags(tags);
      var badgeWrap = card.querySelector('.byb-pcard-badges');
      if (badge) {
        if (!badgeWrap) {
          badgeWrap = document.createElement('div');
          badgeWrap.className = 'byb-pcard-badges';
          var span = document.createElement('span');
          span.className = 'byb-pbadge';
          badgeWrap.appendChild(span);
          card.insertBefore(badgeWrap, card.firstChild);
        }
        var badgeEl = badgeWrap.querySelector('.byb-pbadge');
        var wantCls = 'byb-pbadge ' + badge.cls;
        if (badgeEl.className !== wantCls) badgeEl.className = wantCls;
        if (badgeEl.textContent !== badge.label) badgeEl.textContent = badge.label;
      } else if (badgeWrap) {
        badgeWrap.remove();
      }
    });
  }

  /* =======================================================
     STEP 3 — Review Bundle -> build-your-box.html panel 3
     -------------------------------------------------------
     Rebuild the example layout inside .ab-review-bundle-wrapper:
       LEFT  .byb-review-main : "Your Box" card + "Delivery" card
       RIGHT .byb-review-side : "Order Summary" (moves the real Checkout
                                button in, kept interactive).
     The fulfillment choice is carried to the Shopify cart via a line-item
     property + cart attribute (Appstle's own order note does not propagate).
     ======================================================= */

  var STEP_HEAD_3 = {
    eyebrow: 'Step 03 · Review',
    h2: 'Look It <span class="display-italic">Over.</span>',
    lede: 'Adjust selections, choose your delivery cycle, then checkout. You can change everything after subscribing.'
  };

  var BYB_FULFILLMENT = [
    { id: 'delivery', title: 'Home Delivery', desc: 'Insulated. Tracked. Still frozen at your door.', summary: 'Home delivery' },
    { id: 'pickup',   title: 'Shop Pickup',   desc: 'Free. Skip the shipping. Pick up mid-month.', summary: 'Shop pickup' }
  ];
  var BYB_FULFILLMENT_NOTE_PREFIX = 'Fulfillment: ';

  // Billing cards. `match` = keyword to select Appstle's selling-plan option
  // once the owner adds it. Dates are computed live from `day` so the card
  // always shows the NEXT occurrence (rolls to next month if today has
  // already passed that day). `disabled` greys the card out + badges it.
  var BYB_BILLING = [
    { id: '1',  match: '1st',  title: '1st of the month',  day: 1,  disabled: false },
    { id: '15', match: '15th', title: '15th of the month', day: 15, disabled: true  }
  ];

  var BYB_MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  function bybOrdinal(n) {
    var s = ['th','st','nd','rd'];
    var v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  // Next calendar date for a billing day, from today. If today has already
  // passed that day-of-month, roll to next month. Day is clamped to the
  // last day of the target month (so day 31 in Feb becomes Feb 28/29).
  function bybNextChargeDate(day) {
    var now = new Date();
    var y = now.getFullYear();
    var m = now.getMonth();
    if (now.getDate() > day) {
      m += 1;
      if (m > 11) { m = 0; y += 1; }
    }
    var last = new Date(y, m + 1, 0).getDate();
    var d = Math.min(day, last);
    return new Date(y, m, d);
  }

  // "1st October" — used both in the card and in the Order Summary row.
  function bybChargeLabel(day) {
    var d = bybNextChargeDate(day);
    return bybOrdinal(d.getDate()) + ' ' + BYB_MONTHS[d.getMonth()];
  }

  // Materialise card data with live dates. Rebuilt on every render so the
  // label is correct even if a tab is left open across midnight.
  function bybBuildBillingOptions() {
    return BYB_BILLING.map(function (o) {
      var charge = bybChargeLabel(o.day);
      return {
        id: o.id,
        match: o.match,
        title: o.title,
        day: o.day,
        disabled: !!o.disabled,
        charge: charge,
        ship: 'Right after',
        desc: 'Charged ' + charge + ' · Ships right after'
      };
    });
  }

  var _fulfillment = 'delivery'; // default (Home Delivery selected)
  var _billing = '1';            // default (1st selected)

  // Write the note into Appstle's order-note textarea. Appstle's UI is React:
  // assigning textarea.value directly does NOT update React state, so we use
  // the native value setter React tracks, then fire 'input' so onChange runs.
  function setFulfillmentNote(label) {
    var ta = document.getElementById('ab-order-note');
    if (!ta) return;
    var line = BYB_FULFILLMENT_NOTE_PREFIX + label;
    if (ta.value === line) return;
    try {
      var setter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value').set;
      setter.call(ta, line);
    } catch (e) {
      ta.value = line;
    }
    ta.dispatchEvent(new Event('input', { bubbles: true }));
    ta.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function reassertFulfillmentNote() {
    var opt = BYB_FULFILLMENT.filter(function (o) { return o.id === _fulfillment; })[0];
    if (opt) setFulfillmentNote(opt.title);
  }

  /* CART CARRY-ON: the fulfillment choice to the Shopify order.
       (A) line-item property — intercept /cart/add(.js) and merge
           properties[Fulfillment] into each item.
       (B) cart attribute — POST /cart/update.js {attributes:{Fulfillment}}. */
  var BYB_CART_KEY = 'Fulfillment';

  function currentFulfillmentLabel() {
    var opt = BYB_FULFILLMENT.filter(function (o) { return o.id === _fulfillment; })[0];
    return opt ? opt.title : '';
  }

  function pushFulfillmentAttribute() {
    if (!_origFetch) return;
    var label = currentFulfillmentLabel();
    if (!label) return;
    var attrs = {}; attrs[BYB_CART_KEY] = label;
    try {
      _origFetch.call(window, '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      });
    } catch (e) {}
  }

  function injectPropsIntoBody(body) {
    var label = currentFulfillmentLabel();
    if (!label || typeof body !== 'string') return body;
    if (body.charAt(0) === '{') {
      try {
        var obj = JSON.parse(body);
        var add = function (it) { if (!it || typeof it !== 'object') return; it.properties = it.properties || {}; if (!it.properties[BYB_CART_KEY]) it.properties[BYB_CART_KEY] = label; };
        if (Array.isArray(obj.items)) obj.items.forEach(add);
        else if (obj.id) add(obj);
        return JSON.stringify(obj);
      } catch (e) { return body; }
    }
    // form-encoded
    if (body.indexOf('properties%5B' + BYB_CART_KEY + '%5D') === -1 &&
        body.indexOf('properties[' + BYB_CART_KEY + ']') === -1) {
      body += '&properties%5B' + BYB_CART_KEY + '%5D=' + encodeURIComponent(label);
    }
    return body;
  }

  var _origFetch = (typeof window.fetch === 'function') ? window.fetch.bind(window) : null;
  var _cartInterceptorInstalled = false;
  function isCartAdd(url) { return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url); }

  function installCartInterceptor() {
    if (_cartInterceptorInstalled) return;
    _cartInterceptorInstalled = true;
    if (typeof window.fetch === 'function') {
      var f = window.fetch;
      window.fetch = function (url, opts) {
        try {
          var u = (typeof url === 'string') ? url : (url && url.url);
          if (isCartAdd(u) && opts && opts.body) opts.body = injectPropsIntoBody(opts.body);
        } catch (e) {}
        return f.apply(this, arguments);
      };
    }
    if (window.XMLHttpRequest) {
      var op = window.XMLHttpRequest.prototype.open;
      var sn = window.XMLHttpRequest.prototype.send;
      window.XMLHttpRequest.prototype.open = function (method, url) { this.__bybAdd = isCartAdd(url); return op.apply(this, arguments); };
      window.XMLHttpRequest.prototype.send = function (body) {
        try { if (this.__bybAdd && typeof body === 'string') body = injectPropsIntoBody(body); } catch (e) {}
        return sn.call(this, body);
      };
    }
  }

  // Console diagnostic: push the choice + read /cart.js to see it on the cart.
  window.__bybCartDebug = function () {
    pushFulfillmentAttribute();
    if (_origFetch) {
      _origFetch.call(window, '/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (!window.console) return;
          console.log('[BYB] cart.attributes:', c.attributes);
          console.log('[BYB] line-item properties:', (c.items || []).map(function (i) { return { title: i.title, properties: i.properties }; }));
        })
        .catch(function () {});
    }
    return currentFulfillmentLabel();
  };

  // Best-effort: select a selling-plan option whose text contains `keyword`.
  function selectSellingPlanByKeyword(keyword) {
    var btn = document.querySelector('.ab-selling-plan-field-dropdown');
    if (!btn) return false;
    if ((btn.textContent || '').toLowerCase().indexOf(keyword.toLowerCase()) > -1) return true;
    var opts = document.querySelectorAll('[class*="selling-plan"] [role="option"], [class*="selling-plan-option"]');
    for (var i = 0; i < opts.length; i++) {
      if ((opts[i].textContent || '').toLowerCase().indexOf(keyword.toLowerCase()) > -1) { opts[i].click(); return true; }
    }
    return false;
  }

  function reviewPlanName() {
    var el = document.querySelector('.ab-review-bundle-source-product-title .ab-product-title') ||
             document.querySelector('.ab-review-bundle-source-product-title');
    return el ? el.textContent.trim() : '';
  }
  function reviewTotal() {
    var el = document.querySelector('.ab-subtotal-price');
    return el ? el.textContent.trim() : '';
  }
  function getPlanSelectionsTotal() {
    var name = reviewPlanName();
    var m = /choose\s+(\d+)/i.exec(name || '');
    return m ? parseInt(m[1], 10) : null;
  }
  function reviewCutsCount() {
    var n = 0;
    document.querySelectorAll('.ab-review-bundle-content-item-qty-display').forEach(function (q) {
      var v = parseInt((q.textContent || '').replace(/[^0-9]/g, ''), 10);
      n += isNaN(v) ? 0 : v;
    });
    return n;
  }

  function injectStep3Head() {
    var wrapper = document.querySelector('.ab-review-bundle-wrapper');
    if (!wrapper) return;
    var block = wrapper.closest('.ab-fixed-pricing-source-product-block') || wrapper.parentNode;
    if (!block || !block.parentNode) return;
    if (block.parentNode.querySelector('.byb-step-head-3')) return;
    var head = document.createElement('div');
    head.className = 'byb-step-head-wrap byb-step-head-3';
    head.innerHTML =
      '<div class="wrap"><div class="byb-step-head">' +
        '<div><span class="eyebrow">' + STEP_HEAD_3.eyebrow + '</span>' +
        '<h2 class="mt-3">' + STEP_HEAD_3.h2 + '</h2></div>' +
        '<p class="lede">' + STEP_HEAD_3.lede + '</p>' +
      '</div></div>';
    block.parentNode.insertBefore(head, block);
  }

  function buildReviewLine(li, idx) {
    // Appstle's review item uses .ab-review-bundle-content-item-product-title
    // (with nested spans); .ab-product-title is a Step-2 class. Prefer the
    // review-specific one; keep the old one as a safety fallback.
    var titleEl = li.querySelector('.ab-review-bundle-content-item-product-title') ||
                  li.querySelector('.ab-product-title');
    var name = titleEl ? titleEl.textContent.trim() : '';
    var qtyEl = li.querySelector('.ab-review-bundle-content-item-qty-display');
    var qty = qtyEl ? qtyEl.textContent.replace(/[^0-9]/g, '') : '1';
    var imgEl = li.querySelector('.ab-review-bundle-content-item-image');
    var imgUrl = imgEl ? imgEl.getAttribute('src') : '';
    var tags = resolveCardTags(li);
    var cat = categoryLabelFromTags(tags);
    var sub = '×' + qty + (cat ? ' · ' + cat.toUpperCase() : '');
    var line = document.createElement('div');
    line.className = 'review-line';
    if (idx != null) line.setAttribute('data-idx', idx);
    var photo = imgUrl
      ? '<div class="photo photo-real" style="background-image:url(' + imgUrl + ')"></div>'
      : '<div class="photo"></div>';
    line.innerHTML =
      photo +
      '<div><div class="n">' + name + '</div>' +
      '<div class="review-line-sub">' + sub + '</div></div>' +
      '<span class="rm">Remove</span>';
    return line;
  }

  function buildLeftColumn(layout) {
    var main = layout.querySelector('.byb-review-main');
    if (!main) {
      main = document.createElement('div');
      main.className = 'byb-review-main';
      layout.insertBefore(main, layout.firstChild);
    }

    // "Your Box" card
    var box = main.querySelector('.byb-box-card');
    if (!box) {
      box = document.createElement('div');
      box.className = 'pcard-lg byb-box-card';
      box.innerHTML =
        '<div class="pcard-lg-head"><h3>Your Box</h3><span class="mono byb-box-count"></span></div>' +
        '<div class="byb-box-lines"></div>' +
        '<div style="margin-top:20px;"><button class="link-underline byb-edit-cuts" type="button">← Edit Cuts</button></div>';
      main.appendChild(box);
      box.querySelector('.byb-edit-cuts').addEventListener('click', function () {
        var prev = document.querySelector('.ab-single-product-bab-previous-button');
        if (prev) prev.click();
      });
      // Remove link → proxy-click Appstle's own hidden ✕ button on the
      // matching review item. Index match is safe: our lines and Appstle's
      // li's are both built from .ab-review-bundle-content-item in the same
      // order, at the same time. Event-delegated on the card so it survives
      // the innerHTML rebuild that happens on every sig change.
      box.addEventListener('click', function (e) {
        var rm = e.target.closest('.rm');
        if (!rm || !box.contains(rm)) return;
        var line = rm.closest('.review-line');
        if (!line) return;
        var idx = parseInt(line.getAttribute('data-idx'), 10);
        if (isNaN(idx)) return;
        var items = document.querySelectorAll('.ab-review-bundle-content-item');
        var target = items[idx];
        if (!target) return;
        var btn = target.querySelector('.ab-review-bundle-content-item-remove');
        if (btn) btn.click();
      });
    }
    var linesHost = box.querySelector('.byb-box-lines');
    var items = document.querySelectorAll('.ab-review-bundle-content-item');
    var sig = [].map.call(items, function (li) {
      var t = li.querySelector('.ab-product-title'); var q = li.querySelector('.ab-review-bundle-content-item-qty-display');
      return (t ? t.textContent.trim() : '') + '#' + (q ? q.textContent.trim() : '');
    }).join('|');
    if (linesHost.getAttribute('data-sig') !== sig) {
      linesHost.setAttribute('data-sig', sig);
      linesHost.innerHTML = '';
      [].forEach.call(items, function (li, idx) { linesHost.appendChild(buildReviewLine(li, idx)); });
    }
    var plan = getPlanSelectionsTotal();
    var cutsN = reviewCutsCount();
    var countText = plan ? (cutsN + ' / ' + plan + ' cuts') : (cutsN + ' cuts');
    var countEl = box.querySelector('.byb-box-count');
    if (countEl.textContent !== countText) countEl.textContent = countText;

    // "Delivery" card
    var del = main.querySelector('.byb-delivery-card');
    if (!del) {
      del = document.createElement('div');
      del.className = 'pcard-lg mt-4 byb-delivery-card';
      del.innerHTML =
        '<div class="pcard-lg-head"><h3>Delivery</h3></div>' +
        '<div><span class="byb-delivery-label">Fulfillment</span>' +
          '<div class="byb-freq-grid" id="byb-fulfillment">' +
            BYB_FULFILLMENT.map(function (o) {
              return '<div class="byb-freq-opt" data-ff="' + o.id + '"><h5>' + o.title + '</h5><p>' + o.desc + '</p></div>';
            }).join('') +
          '</div></div>' +
        '<div style="margin-top:24px;"><span class="byb-delivery-label">Order Frequency</span>' +
          '<p class="byb-delivery-note">Pick a monthly cycle day that works for you. Ships right after each charge.</p>' +
          '<div class="byb-freq-grid" id="byb-billing">' +
            bybBuildBillingOptions().map(function (o) {
              return '<div class="byb-freq-opt' + (o.disabled ? ' disabled' : '') + '" data-cycle="' + o.id + '" data-match="' + o.match + '">' +
                (o.disabled ? '<span class="byb-coming-badge">Coming soon</span>' : '') +
                '<h5>' + o.title + '</h5><p>' + o.desc + '</p></div>';
            }).join('') +
          '</div></div>';
      main.appendChild(del);
      del.addEventListener('click', function (e) {
        var ff = e.target.closest('.byb-freq-opt[data-ff]');
        if (ff) {
          _fulfillment = ff.getAttribute('data-ff');
          var opt = BYB_FULFILLMENT.filter(function (o) { return o.id === _fulfillment; })[0];
          if (opt) setFulfillmentNote(opt.title);
          pushFulfillmentAttribute();
          syncStep3UI();
          return;
        }
        var cy = e.target.closest('.byb-freq-opt[data-cycle]');
        if (cy) {
          if (cy.classList.contains('disabled')) return; // Coming soon
          _billing = cy.getAttribute('data-cycle');
          selectSellingPlanByKeyword(cy.getAttribute('data-match')); // no-op until plans exist
          syncStep3UI();
        }
      });
      var def = BYB_FULFILLMENT.filter(function (o) { return o.id === _fulfillment; })[0];
      if (def) setFulfillmentNote(def.title);
    }
  }

  function buildRightColumn(layout) {
    var side = layout.querySelector('.byb-review-side');
    if (!side) {
      side = document.createElement('div');
      side.className = 'byb-review-side';
      layout.appendChild(side);
    }
    var card = side.querySelector('.byb-summary-card');
    if (!card) {
      card = document.createElement('div');
      card.className = 'pcard-lg review-summary byb-summary-card';
      card.innerHTML =
        '<div class="pcard-lg-head"><h3>Order Summary</h3></div>' +
        '<div class="byb-summary-rows">' +
          '<div class="byb-summary-row"><span>Plan&nbsp;</span><span class="byb-sm-plan" style="font-family:var(--pc-serif);"></span></div>' +
          '<div class="byb-summary-row"><span>Cuts included</span><span class="mono byb-sm-cuts"></span></div>' +
          '<div class="byb-summary-row"><span>Delivery</span><span class="byb-sm-ff"></span></div>' +
          '<div class="byb-summary-row"><span>First charge</span><span class="mono byb-sm-charge"></span></div>' +
          '<div class="byb-summary-row"><span>First ship</span><span class="mono byb-sm-ship"></span></div>' +
        '</div>' +
        '<div class="total-row"><span class="lbl">Total / month</span><span class="val byb-sm-total"></span></div>' +
        '<div class="byb-summary-checkout"></div>' +
        '<p class="mono byb-summary-fine">Cancel anytime · No hidden fees</p>';
      side.appendChild(card);
    }
    var checkoutBtn = document.querySelector('.ab-bundle-checkout-button');
    var host = card.querySelector('.byb-summary-checkout');
    if (checkoutBtn && checkoutBtn.parentNode !== host) host.appendChild(checkoutBtn);
  }

  function syncStep3UI() {
    document.querySelectorAll('#byb-fulfillment .byb-freq-opt').forEach(function (el) {
      el.classList.toggle('selected', el.getAttribute('data-ff') === _fulfillment);
    });
    var btn = document.querySelector('.ab-selling-plan-field-dropdown');
    var btnText = btn ? (btn.textContent || '').toLowerCase() : '';
    document.querySelectorAll('#byb-billing .byb-freq-opt').forEach(function (el) {
      el.classList.toggle('selected', el.getAttribute('data-cycle') === _billing);
      var live = btnText.indexOf(el.getAttribute('data-match').toLowerCase()) > -1;
      el.classList.toggle('byb-plan-pending', !live);
    });
    var ffOpt = BYB_FULFILLMENT.filter(function (o) { return o.id === _fulfillment; })[0];
    var bOpt = bybBuildBillingOptions().filter(function (o) { return o.id === _billing; })[0];
    var plan = getPlanSelectionsTotal();
    var set = function (sel, val) { var e = document.querySelector(sel); if (e && e.textContent !== val) e.textContent = val; };
    set('.byb-sm-plan', reviewPlanName());
    set('.byb-sm-cuts', plan ? (reviewCutsCount() + '/' + plan) : String(reviewCutsCount()));
    set('.byb-sm-ff', ffOpt ? ffOpt.summary : '');
    set('.byb-sm-charge', bOpt ? bOpt.charge : '—');
    set('.byb-sm-ship', bOpt ? bOpt.ship : '—');
    set('.byb-sm-total', reviewTotal());
  }

  function injectStep3Nav() {
    var host = document.querySelector('.ab-review-bundle-wrapper');
    if (!host) return;
    if (host.querySelector('.byb-step-nav')) return;
    var nav = document.createElement('div');
    nav.className = 'byb-step-nav';
    nav.innerHTML =
      '<button type="button" class="byb-back-btn">← Back to Cuts</button>' +
      '<button type="button" class="byb-continue-btn">Continue to Cart</button>';
    host.appendChild(nav);
    nav.querySelector('.byb-back-btn').addEventListener('click', function () {
      var prev = document.querySelector('.ab-single-product-bab-previous-button');
      if (prev) prev.click();
    });
    nav.querySelector('.byb-continue-btn').addEventListener('click', function () {
      pushFulfillmentAttribute();
      var co = document.querySelector('.ab-bundle-checkout-button');
      if (co) co.click();
    });
  }

  function relabelCheckout() {
    var btn = document.querySelector('.ab-bundle-checkout-button');
    if (!btn) return;
    btn.classList.add('byb-checkout');
    var want = 'Continue to Cart';

    // Collect ALL direct-child text nodes with visible content. Appstle's
    // React re-render (triggered by the click) can insert its own text node
    // alongside the one we added manually, which produces
    // "Continue to CartContinue to Cart". Keep exactly one — the first —
    // and remove any extras so the label stays single across re-renders.
    var textNodes = [];
    btn.childNodes.forEach(function (n) {
      if (n.nodeType === 3 && n.textContent.trim()) textNodes.push(n);
    });

    if (textNodes.length === 0) {
      btn.insertBefore(document.createTextNode(want), btn.firstChild);
    } else {
      if (textNodes[0].textContent.trim() !== want) textNodes[0].textContent = want;
      for (var i = 1; i < textNodes.length; i++) {
        if (textNodes[i].parentNode) textNodes[i].parentNode.removeChild(textNodes[i]);
      }
    }

    if (!btn.getAttribute('data-byb-cart')) {
      btn.setAttribute('data-byb-cart', '1');
      btn.addEventListener('click', function () { pushFulfillmentAttribute(); }, true);
    }
  }

  var _step3AttrPushed = false;
  function augmentStep3() {
    installCartInterceptor(); // line-item property on Appstle's add-to-cart
    injectStep3Head();
    var layout = document.querySelector('.ab-review-bundle-layout');
    if (layout) {
      buildLeftColumn(layout);
      buildRightColumn(layout);
      syncStep3UI();
    }
    injectStep3Nav();
    relabelCheckout();
    reassertFulfillmentNote();
    if (!_step3AttrPushed) { _step3AttrPushed = true; pushFulfillmentAttribute(); }
    setNavLabels(null, 'Back to Cuts');
  }

  /* =======================================================
     STEP 2 — Meter panel (build-your-box .meter-panel)
     -------------------------------------------------------
     Inject a .meter-info heading + a "N selected / N remaining" label row
     into Appstle's progress strip; parse used/total from the strip text.
     Re-asserted every tick (guarded so a settled panel is a no-op).
     ======================================================= */
  var METER_SUB = 'Every eligible cut counts as one selection. Add up to your plan’s total.';

  // Premium counter:
  //   used  = premium-tagged cuts currently in the box
  //   total = the plan's premium cap from pc-bundle-config (premiumMax) when set;
  //           otherwise the count of premium-tagged products on the page (legacy).
  // 0/0 until either a premiumMax is configured or a product is premium-tagged.
  function premiumCounts() {
    var pool = 0, used = 0;
    document.querySelectorAll('.ab-associated-product-item').forEach(function (card) {
      if (resolveCardTags(card).indexOf('premium') === -1) return;
      pool++;
      if (card.querySelector('.ab-product-quantity')) used++;
    });
    var cap = bybPremiumMax(); // 0 = not configured
    return { used: used, total: cap > 0 ? cap : pool };
  }

  // Parse "N item(s) added with a minimum quantity of T" -> { used, total }.
  // PRIMARY, AUTOMATIC SOURCE: Appstle prints this text in its own progress
  // strip (.ab-progress-bar-text). It carries BOTH the current count (N) and
  // the bundle's target/max (T) — so we never hardcode a max or ask the client
  // to maintain one. It updates live as the customer adds cuts. Returns null
  // only if the text is absent (e.g. a build with the restriction lifted), in
  // which case we fall back to counting cards / the plan tables.
  function parseMeterCounts(text) {
    if (!text) return null;
    var used = null, total = null;
    var mUsed = /(\d+)\s*items?\s*added/i.exec(text);
    if (mUsed) used = parseInt(mUsed[1], 10);
    var mTot = /(?:minimum|maximum|of)\s+(?:quantity\s+of\s+)?(\d+)/i.exec(text);
    if (mTot) total = parseInt(mTot[1], 10);
    if (used === null && total === null) return null;
    return { used: used || 0, total: total || 0 };
  }

  // Read Appstle's native progress text wherever it is on the page (the strip
  // is duplicated into the dockbar, so query document-wide and take the first
  // that parses). This is the automatic, zero-maintenance meter source.
  function nativeMeterCounts() {
    var els = document.querySelectorAll('.ab-progress-bar-text');
    for (var i = 0; i < els.length; i++) {
      var c = parseMeterCounts(els[i].textContent);
      if (c) return c;
    }
    return null;
  }

  // Resolve the meter's { used, total } for THIS tick. Appstle's native text is
  // authoritative for both when present; otherwise we count selected cards and
  // fall back to the plan max. `used` takes the larger of the native count and
  // our own card count so it tracks whichever UI Appstle is using.
  function meterCounts() {
    var native = nativeMeterCounts();
    var total = bybMax();               // native-first, and caches the value
    var used = bybUsed();
    if (native && native.used > used) used = native.used;
    return { used: used, total: total };
  }

  // USED = how many cuts are in the box right now. Each selected Step-2 card
  // shows a qty stepper (.ab-product-quantity); we sum those values so a cut
  // added more than once counts correctly. Independent of Appstle's (removed)
  // progress text.
  function bybUsed() {
    var n = 0;
    document.querySelectorAll('.ab-associated-product-item .ab-product-quantity').forEach(function (q) {
      var v = parseInt((q.value || q.textContent || '').replace(/[^0-9]/g, ''), 10);
      n += isNaN(v) ? 0 : v;
    });
    return n;
  }

  // Client-editable bundle config: snippets/pc-bundle-config.liquid prints
  //   <script id="pc-bundle-config">{"byPrice":{"129":{max,premiumMax},...}}</script>
  // Appstle does NOT expose a bundle's max cut count anywhere readable, so this
  // map (keyed by plan PRICE) is the source of truth. One place the client edits.
  var _bundleConfig; // undefined = not parsed; null = absent
  function getBundleConfig() {
    if (_bundleConfig !== undefined) return _bundleConfig;
    var el = document.getElementById('pc-bundle-config');
    if (!el) { _bundleConfig = null; return null; }
    try {
      var parsed = JSON.parse(el.textContent);
      _bundleConfig = (parsed && typeof parsed === 'object') ? parsed : null;
    } catch (e) { _bundleConfig = null; }
    return _bundleConfig;
  }

  // The plan price the customer chose: ?plan= first, else the selected plan card.
  function currentPlanPrice() {
    var p = getPreselectPrice();
    if (p) return p;
    var sel = document.querySelector('.ab-single-source-selected-product .ab-single-source-product-variant-price');
    if (sel) { var k = priceKey(sel.textContent); if (k) return k; }
    return '';
  }

  // MAX = this bundle's total cut count. Sources, most reliable first:
  //   1) Appstle's native progress text ("...minimum quantity of N") — the
  //      REAL value, straight from Appstle, fully automatic, zero client
  //      maintenance. This is the source we use in practice.
  //   2..) Safety nets only, reached solely if that text is ever absent:
  //      cached last-known value, then client config map, plan tables, and the
  //      Step-3 "Choose N" title. None of these fire while the native text
  //      renders, so the client never has to touch a config value.
  // Cached once found so it survives re-renders and brief re-render gaps.
  var _bybMax = 0;
  function planMaxFromPrice(priceKeyStr) {
    // Prefer Appstle's config (matched by source-product price).
    var settings = getSingleProductSettings();
    if (settings) {
      for (var i = 0; i < settings.length; i++) {
        var sp = settings[i].sourceProduct || {};
        if (priceKey(sp.price) === priceKeyStr) return entryMax(settings[i]);
      }
    }
    // Legacy fallback: parse "N selections" out of the plan table.
    var plan = PLAN_BY_PRICE[priceKeyStr];
    if (!plan) return 0;
    var m = /(\d+)\s*selection/i.exec(plan.selections || '');
    return m ? parseInt(m[1], 10) : 0;
  }

  /* =======================================================
     BUNDLE MAX — from Appstle's own runtime config (_ABConfig)
     -------------------------------------------------------
     The min-qty restriction was removed, which also killed the
     native progress strip that used to render "N items added
     with a minimum quantity of T" — our only automatic source
     of T. But Appstle still ships the bundle rule on the page
     so its React widget can enforce the ceiling:

       _ABConfig.bundle_rules[i].singleProductSettings
         = JSON string, one entry per plan (source product),
           each carrying maxQuantity (the cut target) and
           minQuantity.

     We read that. Automatic, zero-config, survives re-renders
     and the removal of the native strip.

     Which entry applies depends on the chosen plan. On Step 1
     the plan cards are still in the DOM (title is hidden by
     CSS, not removed), so we match the selected card to an
     entry by source-product title, then image filename, then
     positional index, and cache the max in sessionStorage.
     On Step 2/3 the cards are gone, so we read the cached
     value; a direct refresh onto Step 2/3 with ?plan=… is
     covered by a rank-match on source-product price.
     ======================================================= */

  var _singleProductSettings = null; // memoised parsed array
  var _bundleMaxFromConfig = 0;      // current plan's max cuts

  function getCurrentBundleRule() {
    if (typeof window._ABConfig === 'undefined' || !window._ABConfig) return null;
    var rules = window._ABConfig.bundle_rules;
    if (!rules || !rules.length) return null;
    var m = /\/apps\/bundles\/[^\/]+\/([A-Za-z0-9]+)/.exec(location.pathname);
    if (m) {
      for (var i = 0; i < rules.length; i++) {
        if (rules[i] && rules[i].uniqueRef === m[1]) return rules[i];
      }
    }
    return rules[0];
  }

  function getSingleProductSettings() {
    if (_singleProductSettings) return _singleProductSettings;
    var rule = getCurrentBundleRule();
    if (!rule) return null;
    var raw = rule.singleProductSettings;
    if (!raw) return null;
    try {
      var arr = (typeof raw === 'string') ? JSON.parse(raw) : raw;
      if (Array.isArray(arr) && arr.length) {
        _singleProductSettings = arr;
        return arr;
      }
    } catch (e) { /* fall through */ }
    return null;
  }

  function entryMax(entry) {
    if (!entry) return 0;
    var m = parseInt(entry.maxQuantity, 10);
    if (!m) m = parseInt(entry.minQuantity, 10);
    return m || 0;
  }

  function findEntryForCard(card, settings) {
    var cards = document.querySelectorAll('.ab-single-source-product-item');
    var titleEl = card.querySelector('.ab-single-source-product-title');
    var cardTitle = titleEl ? normalizeTitle(titleEl.textContent) : '';
    var imgEl = card.querySelector('img[src]');
    var cardImgKey = imgEl ? imageFileKey(imgEl.getAttribute('src')) : '';
    var i, sp;

    if (cardTitle) {
      for (i = 0; i < settings.length; i++) {
        sp = settings[i].sourceProduct || {};
        if (normalizeTitle(sp.title) === cardTitle) return settings[i];
      }
    }
    if (cardImgKey) {
      for (i = 0; i < settings.length; i++) {
        sp = settings[i].sourceProduct || {};
        if (sp.imageSrc && imageFileKey(sp.imageSrc) === cardImgKey) return settings[i];
      }
    }
    var idx = Array.prototype.indexOf.call(cards, card);
    if (idx >= 0 && idx < settings.length) return settings[idx];
    return null;
  }

  // Step 1 only: read the max from the plan card the customer actually has
  // selected. The URL's ?plan= is a HINT (initial landing / deep link), but
  // it can lag behind the customer's clicks because Appstle's card click
  // doesn't rewrite the query string on its own. So we prefer:
  //   1) the card Appstle has marked .ab-single-source-selected-product
  //   2) the card matching ?plan= (used only until a selection exists)
  function tryCaptureCurrentPlanMax() {
    var settings = getSingleProductSettings();
    if (!settings) return;
    var cards = document.querySelectorAll('.ab-single-source-product-item');
    if (!cards.length) return;

    var selectedCard = null;
    cards.forEach(function (c) {
      if (!selectedCard && c.classList.contains('ab-single-source-selected-product')) selectedCard = c;
    });

    var urlCard = null;
    var wantPrice = getPreselectPrice();
    if (wantPrice) {
      cards.forEach(function (c) {
        if (urlCard) return;
        var p = c.querySelector('.ab-single-source-product-variant-price');
        if (p && priceKey(p.textContent) === wantPrice) urlCard = c;
      });
    }

    var card = selectedCard || urlCard;
    if (!card) return;

    var max = entryMax(findEntryForCard(card, settings));
    if (!max) return;
    _bundleMaxFromConfig = max;

    // Persist under the card's own price (authoritative) and, if we have
    // one, the URL's price (keeps the per-plan cache warm for deep links).
    var cardPrice = '';
    var priceEl = card.querySelector('.ab-single-source-product-variant-price');
    if (priceEl) cardPrice = priceKey(priceEl.textContent);
    try {
      if (cardPrice) sessionStorage.setItem('byb_bundle_max_' + cardPrice, String(max));
      if (wantPrice && wantPrice !== cardPrice) {
        sessionStorage.setItem('byb_bundle_max_' + wantPrice, String(max));
      }
    } catch (e) {}
  }

  /* =======================================================
     PLAN URL SYNC — keep ?plan= in step with the actual card
     -------------------------------------------------------
     Appstle's card click updates React state but never the
     browser URL, so ?plan= on entry can diverge from the plan
     the customer actually picked on Step 1. The meter, dockbar,
     session cache and refresh all key off ?plan=, so we sync it
     via history.replaceState whenever a card is clicked.
     replaceState fires no popstate and reloads nothing —
     Appstle's React state is untouched; we only fix the URL
     hint so downstream reads stay correct.
     ======================================================= */
  var _planUrlListenerInstalled = false;
  function installPlanUrlSync() {
    if (_planUrlListenerInstalled) return;
    var list = document.querySelector('.ab-fixed-pricing-source-products-list');
    if (!list) return;
    _planUrlListenerInstalled = true;
    list.addEventListener('click', function (e) {
      var card = e.target.closest('.ab-single-source-product-item');
      if (!card) return;
      var priceEl = card.querySelector('.ab-single-source-product-variant-price');
      if (!priceEl) return;
      var key = priceKey(priceEl.textContent);
      if (!key || !PLAN_BY_PRICE[key]) return;
      try {
        var u = new URL(location.href);
        if (u.searchParams.get('plan') !== key) {
          u.searchParams.set('plan', key);
          history.replaceState(null, '', u.pathname + u.search + u.hash);
        }
      } catch (err) {}
    });
  }

  // Fallback for a direct landing on Step 2/3 with ?plan=…
  function getBundleMaxFromConfigByRank(planKey) {
    var settings = getSingleProductSettings();
    if (!settings || !settings.length) return 0;
    var pk = parseInt(planKey, 10);
    if (!pk) return 0;

    var sortedEntries = settings.slice().sort(function (a, b) {
      var pa = parseFloat((a.sourceProduct || {}).price) || 0;
      var pb = parseFloat((b.sourceProduct || {}).price) || 0;
      return pa - pb;
    });
    var planKeys = Object.keys(PLAN_BY_PRICE)
      .map(function (k) { return parseInt(k, 10); })
      .filter(function (n) { return n > 0; })
      .sort(function (a, b) { return a - b; });
    var rank = planKeys.indexOf(pk);
    if (rank < 0 || rank >= sortedEntries.length) return 0;
    return entryMax(sortedEntries[rank]);
  }

  // Tracks the ?plan= value we last saw, so a URL change (manual edit,
  // browser Back/Forward, or our own card-click sync) invalidates any
  // captured max and forces a fresh derive.
  var _lastSeenPlanParam;

  function getConfigDerivedMax() {
    var pk = getPreselectPrice();

    if (pk !== _lastSeenPlanParam) {
      _lastSeenPlanParam = pk;
      _bundleMaxFromConfig = 0;
    }

    // PRIMARY: the value captured on Step 1 from the card the customer
    // actually picked. tryCaptureCurrentPlanMax() now prefers the selected
    // card over the URL, so this survives the case where ?plan= lagged
    // behind an in-app plan change.
    if (_bundleMaxFromConfig) return _bundleMaxFromConfig;

    // FALLBACK 1: derive from _ABConfig using the URL's plan — covers a
    // cold landing straight on Step 2/3 (no Step 1 pass), and any manual
    // URL swap the customer made after arriving.
    if (pk) {
      var m = getBundleMaxFromConfigByRank(pk);
      if (m) { _bundleMaxFromConfig = m; return m; }
    }

    // FALLBACK 2: per-plan sessionStorage. Strictly keyed by the current
    // plan; no plan-agnostic 'default' fallback.
    try {
      if (pk) {
        var raw = sessionStorage.getItem('byb_bundle_max_' + pk);
        if (raw) { var n = parseInt(raw, 10); if (n) return n; }
      }
    } catch (e) {}

    return 0;
  }

  function bybMax() {
    // 0) Appstle's own config — authoritative, automatic, zero-config.
    var cfgMax = getConfigDerivedMax();
    if (cfgMax) return cfgMax;

    // 1) Appstle's native progress text (only present when the min-qty
    //    restriction is active; kept as a secondary source).
    var native = nativeMeterCounts();
    if (native && native.total) { _bybMax = native.total; return _bybMax; }
    // 1b) last value learned from that text.
    if (_bybMax) return _bybMax;

    // 2) optional client config map (only if that snippet exists).
    var price = currentPlanPrice();
    var cfgMap = getBundleConfig();
    if (price && cfgMap && cfgMap.byPrice && cfgMap.byPrice[price] && cfgMap.byPrice[price].max) {
      _bybMax = cfgMap.byPrice[price].max; return _bybMax;
    }
    // 3) plan table fallback.
    if (price) { var m1 = planMaxFromPrice(price); if (m1) { _bybMax = m1; return _bybMax; } }
    // 4) Step-3 source title, e.g. "…Choose 5…"
    var titleEl = document.querySelector('.ab-review-bundle-source-product-title .ab-product-title, .ab-review-bundle-source-product-title');
    if (titleEl) { var m3 = /choose\s+(\d+)/i.exec(titleEl.textContent || ''); if (m3) { _bybMax = parseInt(m3[1], 10); return _bybMax; } }
    return 0; // unknown yet
  }

  // Premium cap from the client config (per plan price); 0 = no cap.
  function bybPremiumMax() {
    var price = currentPlanPrice();
    var cfg = getBundleConfig();
    if (price && cfg && cfg.byPrice && cfg.byPrice[price] && typeof cfg.byPrice[price].premiumMax === 'number') {
      return cfg.byPrice[price].premiumMax;
    }
    return 0;
  }

  function augmentMeter() {
    // Prefer the in-flow strip (the meter); skip the dockbar copy, which
    // augmentDockbar() owns. Appstle may mount both with the same id, so we
    // scan all candidates and take the first NOT inside .ab-bundle-strip-dockbar.
    var strip = null;
    var candidates = document.querySelectorAll('#ab-fixed-pricing-bundle-strip-section, .ab-fixed-pricing-bundle-strip-section');
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i].closest('.ab-bundle-strip-dockbar')) { strip = candidates[i]; break; }
    }
    if (!strip) return;

    var stripParent = strip.parentNode;
    if (stripParent && !stripParent.classList.contains('wrap')) {
      var stripWrap = document.createElement('div');
      stripWrap.className = 'wrap';
      stripParent.insertBefore(stripWrap, strip);
      stripWrap.appendChild(strip);
    }

    // Counts: prefer Appstle's native progress text (automatic max + live
    // count); fall back to counting selected cards / the plan max.
    var mc = meterCounts();
    var used = mc.used;
    var total = mc.total;
    var remain = Math.max(0, total - used);
    var pct = total ? Math.min(100, Math.round((used / total) * 100)) : 0;

    var info = strip.querySelector('.byb-meter-info');
    if (!info) {
      info = document.createElement('div');
      info.className = 'byb-meter-info';
      info.innerHTML =
        '<h4 class="byb-meter-title">' +
          '<span class="byb-meter-title-text"></span>' +
          '<span class="byb-meter-premium"></span>' +
        '</h4>' +
        '<p class="byb-meter-sub"></p>';
      strip.insertBefore(info, strip.firstChild);
    }
    var titleTextEl = info.querySelector('.byb-meter-title-text');
    var subEl = info.querySelector('.byb-meter-sub');
    // Example wording: "6 of 6 cuts selected"
    var titleText = total ? (used + ' of ' + total + ' cuts selected') : (used + ' cuts selected');
    if (titleTextEl.textContent !== titleText) titleTextEl.textContent = titleText;
    if (subEl.textContent !== METER_SUB) subEl.textContent = METER_SUB;

    var premEl = info.querySelector('.byb-meter-premium');
    var prem = premiumCounts();
    var premText = 'Premium ' + prem.used + '/' + prem.total;
    if (premEl.textContent !== premText) premEl.textContent = premText;
    var premFull = prem.total > 0 && prem.used >= prem.total;
    if (premEl.classList.contains('full') !== premFull) premEl.classList.toggle('full', premFull);

    // Progress wrapper: Appstle's may be gone now (it removed the native bar
    // with the restriction). Reuse it if present, else build our own so the
    // meter always has a bar to drive.
    var wrapper = strip.querySelector('.ab-progress-bar-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'ab-progress-bar-wrapper byb-meter-progress';
      wrapper.innerHTML =
        '<div class="ab-progress-bar byb-meter-bar">' +
          '<div class="ab-progress byb-meter-fill" style="width:0%">&nbsp;</div>' +
        '</div>';
      strip.appendChild(wrapper);
    }

    var labelRow = wrapper.querySelector('.byb-meter-row');
    if (!labelRow) {
      labelRow = document.createElement('div');
      labelRow.className = 'byb-meter-row';
      labelRow.innerHTML = '<span class="byb-meter-used"></span><span class="byb-meter-cap"></span>';
      wrapper.insertBefore(labelRow, wrapper.firstChild);
    }
    var usedEl = labelRow.querySelector('.byb-meter-used');
    var capEl = labelRow.querySelector('.byb-meter-cap');
    var usedText = used + ' selected';
    var capText = remain + ' remaining';
    if (usedEl.textContent !== usedText) usedEl.textContent = usedText;
    if (capEl.textContent !== capText) capEl.textContent = capText;

    var fill = wrapper.querySelector('.ab-progress');
    if (fill) {
      var wantW = pct + '%';
      if (fill.style.width !== wantW) fill.style.width = wantW;
      var isFull = total > 0 && used >= total;
      if (fill.classList.contains('byb-meter-full') !== isFull) {
        fill.classList.toggle('byb-meter-full', isFull);
      }
    }
  }

  /* =======================================================
     STEP 2 — Sticky dockbar nav (utilise Appstle's bottom dockbar)
     -------------------------------------------------------
     Appstle renders a sticky bottom bar (.ab-bundle-strip-dockbar) with
     the product avatars + count (left) and the progress bar (right). We
     inject a middle block of nav buttons into its strip section so the
     customer can go Back to Plan / Review Box from anywhere without
     scrolling to the page-bottom nav (which still stays where it is).

     The injected buttons proxy-click Appstle's REAL prev/next buttons
     (never recreated/destroyed). The "Review Box" button mirrors the real
     Next button's disabled state, so it can't advance before the minimum
     is met. Re-asserted every tick (Appstle re-renders the strip); guarded
     so a settled bar makes no DOM writes.
     ======================================================= */
  function augmentDockbar() {
    var dock = document.querySelector('.ab-bundle-strip-dockbar');
    if (!dock) return;
    var strip = dock.querySelector('#ab-fixed-pricing-bundle-strip-section, .ab-fixed-pricing-bundle-strip-section');
    if (!strip) return;

    var mc = meterCounts();
    var used = mc.used;
    var total = mc.total;
    var remain = Math.max(0, total - used);
    var pct = total ? Math.min(100, Math.round((used / total) * 100)) : 0;

    // --- Progress cluster (center): "N selected / R remaining" + a bar. ---
    // Driven from the native progress text (automatic max) when present, else
    // from used/max. CSS lays out the strip as:
    //   toprow (products/count, left) | progress (center) | nav (right).
    var prog = strip.querySelector('.byb-dock-progress');
    if (!prog) {
      prog = document.createElement('div');
      prog.className = 'byb-dock-progress';
      prog.innerHTML =
        '<div class="byb-dock-meter-row">' +
          '<span class="byb-dock-used"></span><span class="byb-dock-cap"></span>' +
        '</div>' +
        '<div class="byb-dock-bar"><div class="byb-dock-fill" style="width:0%">&nbsp;</div></div>';
      // Insert right after the toprow (products/count) so order is left→right.
      var toprow = strip.querySelector('.ab-fixed-pricing-bundle-strip-toprow');
      if (toprow && toprow.nextSibling) strip.insertBefore(prog, toprow.nextSibling);
      else if (toprow) strip.appendChild(prog);
      else strip.insertBefore(prog, strip.firstChild);
    } else if (prog.parentNode !== strip) {
      strip.appendChild(prog);
    }
    var du = prog.querySelector('.byb-dock-used');
    var dc = prog.querySelector('.byb-dock-cap');
    var uT = used + ' selected';
    var cT = total ? (remain + ' remaining') : '';
    if (du.textContent !== uT) du.textContent = uT;
    if (dc.textContent !== cT) dc.textContent = cT;
    var dfill = prog.querySelector('.byb-dock-fill');
    if (dfill) {
      var w = pct + '%';
      if (dfill.style.width !== w) dfill.style.width = w;
      var full = total > 0 && used >= total;
      if (dfill.classList.contains('full') !== full) dfill.classList.toggle('full', full);
    }

    // --- Nav (far right): Back to Plan / Review Box, proxy-click the reals. ---
    var nav = strip.querySelector('.byb-dock-nav');
    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'byb-dock-nav';
      nav.innerHTML =
        '<button type="button" class="byb-dock-prev">← Back to Plan</button>' +
        '<button type="button" class="byb-dock-next">Review Box →</button>';
      strip.appendChild(nav); // last child → far right

      nav.querySelector('.byb-dock-prev').addEventListener('click', function () {
        var prev = document.querySelector('.ab-single-product-bab-previous-button');
        if (prev) prev.click();
      });
      nav.querySelector('.byb-dock-next').addEventListener('click', function () {
        var next = document.querySelector('.ab-single-product-bab-next-button');
        if (next && !next.disabled && !next.hasAttribute('disabled')) next.click();
      });
    } else if (nav !== strip.lastElementChild) {
      strip.appendChild(nav); // keep nav last (far right) after any re-render
    }

    // Mirror the real Next button's enabled/disabled state onto our button.
    var realNext = document.querySelector('.ab-single-product-bab-next-button');
    var nextBtn = nav.querySelector('.byb-dock-next');
    if (realNext && nextBtn) {
      var disabled = realNext.disabled || realNext.hasAttribute('disabled');
      if (nextBtn.disabled !== disabled) nextBtn.disabled = disabled;
    }
  }

  /* =======================================================
     STEP 2 — Filter chips (build-your-box .filter-row / .fchip)
     -------------------------------------------------------
     Inject a chip row above the grid: All + one chip per tag actually
     present on the products. Clicking a chip shows only cards whose tags
     include it. Chips rebuilt only when the present-tag set changes; the
     active filter is re-applied every tick (Appstle re-renders cards).
     ======================================================= */
  var BYB_FILTER_ORDER = [
    { id: 'all', label: 'All' },
    { id: 'beef', label: 'Beef' },
    { id: 'pork', label: 'Pork' },
    { id: 'chicken', label: 'Chicken' },
    { id: 'lamb', label: 'Lamb' },
    { id: 'steak', label: 'Steaks' },
    { id: 'sausage', label: 'Sausage' },
    { id: 'new', label: 'New' }
  ];
  var _activeFilter = 'all';

  function applyFilter() {
    document.querySelectorAll('.ab-associated-product-item-wrapper').forEach(function (wrap) {
      var card = wrap.querySelector('.ab-associated-product-item');
      var show = (_activeFilter === 'all');
      if (!show && card) show = resolveCardTags(card).indexOf(_activeFilter) > -1;
      if (wrap.classList.contains('byb-hidden') === show) {
        wrap.classList.toggle('byb-hidden', !show);
      }
    });
  }

  function augmentFilters() {
    var list = document.querySelector('.ab-fixed-pricing-source-product-associated-products-list');
    if (!list) return;

    var present = {};
    document.querySelectorAll('.ab-associated-product-item').forEach(function (card) {
      resolveCardTags(card).forEach(function (t) { present[t] = true; });
    });
    var chips = BYB_FILTER_ORDER.filter(function (c) { return c.id === 'all' || present[c.id]; });
    if (chips.length <= 1) return; // no tags resolved yet — no chips to show

    var sig = chips.map(function (c) { return c.id; }).join(',');

    var row = document.querySelector('.byb-filter-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'byb-filter-row';
      row.addEventListener('click', function (e) {
        var chip = e.target.closest('.byb-fchip');
        if (!chip) return;
        _activeFilter = chip.getAttribute('data-f');
        row.querySelectorAll('.byb-fchip').forEach(function (el) {
          el.classList.toggle('active', el.getAttribute('data-f') === _activeFilter);
        });
        applyFilter();
      });
      // block > .wrap > [ .byb-filter-row , ...associated-products-list ]
      var filterWrap = document.createElement('div');
      filterWrap.className = 'wrap';
      list.parentNode.insertBefore(filterWrap, list);
      filterWrap.appendChild(row);
      filterWrap.appendChild(list);
    }
    // Re-assert the arrangement (Appstle may re-render the grid out of the wrap).
    var wrapEl = row.parentNode;
    if (list.parentNode !== wrapEl) wrapEl.appendChild(list);
    if (wrapEl.firstChild !== row) wrapEl.insertBefore(row, wrapEl.firstChild);

    if (row.getAttribute('data-sig') !== sig) {
      row.setAttribute('data-sig', sig);
      if (!chips.some(function (c) { return c.id === _activeFilter; })) _activeFilter = 'all';
      row.innerHTML = chips.map(function (c) {
        return '<button class="byb-fchip' + (c.id === _activeFilter ? ' active' : '') +
          '" data-f="' + c.id + '">' + c.label + '</button>';
      }).join('');
    }
    applyFilter();
  }

  /* =======================================================
     Observer / tick
     ======================================================= */
  var currentStep = 0;
  function onStepChange(step) { setBodyStep(step); }

  function tick() {
    var step = detectStep();
    if (step) injectHero();
    if (step === 1) {
      injectStepper(1);
      injectStepHead(STEP_HEAD, document.querySelector('.ab-fixed-pricing-source-product-block'), 'byb-step-head-1');
      augmentStep1();
      injectComingSoon();
      applyPreselect();
      applyAutoAdvance();
      installPlanUrlSync();
      tryCaptureCurrentPlanMax();
      setNavLabels('Continue');
      injectCancel();
    } else if (step === 2) {
      injectStepper(2);
      var strip = document.querySelector('#ab-fixed-pricing-bundle-strip-section');
      var anchor = strip ? (strip.closest('.ab-flex.ab-flex-col.ab-gap-2') || strip) : null;
      injectStepHead(STEP_HEAD_2, anchor, 'byb-step-head-2');
      setNavLabels('Review Box', 'Back to Plan');
      augmentMeter();
      augmentStep2();
      augmentFilters();
      augmentDockbar();
    } else if (step === 3) {
      injectStepper(3);
      augmentStep3();
    }
    if (step && step !== currentStep) {
      currentStep = step;
      onStepChange(step);
    }
  }

  var observer = new MutationObserver(tick);
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();